const LANG_KO = {
    "text_00" : "찰리(CHARLI)",
    "text_01" : "로그인 후 이용해 주십시요",
    "text_02" : "그리팅 메시지 설정",
    "text_03" : "메뉴 위치",
    "text_04" : "챗봇 테마",
    "text_05" : "그리팅메시지로 받고 싶은 정보를 ON 해주세요!",
    "text_06" : "그리팅메시지는 최대 5개까지 설정 가능합니다.",
    "text_07" : "실시간 TOP 답변",
    "text_08" : "질문을 입력하세요.",
    "text_09" : "자동완성 기능",
    "text_10" : "즐겨찾는 질문",
    "text_11" : "아직 즐겨찾는 질문이 없네요😥<br/>찰리에게 질문을 입력한 후 질문 말풍선의 <span className=\"ico_comm ico_bookmark\">북마크</span>를<br/> 누르면 즐겨찾는 질문으로 등록이 가능해요😉",
    "text_12" : "즐겨찾는 질문 추가",
    "text_13" : "위 질문을 즐겨찾는 질문으로 추가하실래요?",
    "text_14" : "즐겨찾는 질문은 총 10개까지만<br/>등록 가능해요😥<br/>등록된 질문을 삭제한 후<br/>등록이 가능합니다!",
    "text_15" : "즐겨찾는 질문 삭제",
    "text_16" : "위 질문을 즐겨찾는 질문에서 삭제하실래요?",
    "text_17" : "찰리(CHARLI) 의견 제안",
    "text_18" : "찰리(CHARLI)에 대한 의견을 <br/> 제안해주세요😀",
    "text_19" : "소중한 의견 작성",
    "text_20" : "불필요한 개인정보가 포함되지 않도록 작성 시 유의해주세요.",
    "text_21" : "여러분의 소중한 의견을 입력해주세요. (글자수 1000자 제한)",
    "text_22" : "소중한 의견이 접수되었습니다.",
    "text_23" : "중앙대학교 챗봇",
    "text_24" : "로그인",
    "text_25" : "좌",
    "text_26" : "우",
    "text_27" : "로그아웃",
    "text_28" : "님",
    "text_29" : "확인",
    "text_30" : "예",
    "text_31" : "아니오",
    "text_32" : "그리팅 메시지 설정은 준비중입니다.",
    "text_33" : "보내기",
    "text_34" : "선택해주세요.",
    "text_35" : "선택",
    "text_36" : "실시간 TOP 답변이 조회되지 않았습니다.",
    "text_37" : "GPT 사용",
    "text_38" : "자동",
    "text_39" : "수동"

}

const LANG_EN = {
    "text_00" : "CHARLI",
    "text_01" : "Log in before using",
    "text_02" : "Greeting text setting",
    "text_03" : "Menu location",
    "text_04" : "Chatbot theme",
    "text_05" : "Turn on the information you want to receive as a greeting text!",
    "text_06" : "You can set up to 5 greeting texts.",
    "text_07" : "Real-time TOP answer ",
    "text_08" : "How can I help you?",
    "text_09" : "Auto-complete function",
    "text_10" : "Favorite question",
    "text_11" : "There are no favorite questions 😥<br/>After asking a question to CHARLI, click ☆ on the question bubble to register it as a favorite question😉",
    "text_12" : "Add your favorite questions",
    "text_13" : "Do you want to add the above question as your favorite question?",
    "text_14" : "You can register up to 5 favorite questions😥<br/>You can register after deleting the registered question!",
    "text_15" : "Delete a favorite question",
    "text_16" : "Do you want to remove the above question from your favorite questions?",
    "text_17" : "Suggestions for chatbot",
    "text_18" : "Please suggest comments on the chatbot 😀",
    "text_19" : "Write your valuable opinion",
    "text_20" : "Please be careful when writing not to include unnecessary personal information.",
    "text_21" : "Please enter the appropriate answer to your question. (Up to 1000 characters)",
    "text_22" : "Your valuable opinion has been accepted.",
    "text_23" : "A chatbot at Chung-Ang University",
    "text_24" : "Log-in",
    "text_25" : "left",
    "text_26" : "right",
    "text_27" : "Log-out",
    "text_28" : "",
    "text_29" : "Confirm",
    "text_30" : "Yes",
    "text_31" : "No",
    "text_32" : "The greeting message service is not yet available.",
    "text_33" : "Send",
    "text_34" : "Please select.",
    "text_35" : "select",
    "text_36" : "No real-time TOP answers were inquired.",
    "text_37" : "Use GPT",
    "text_38" : "Automatic",
    "text_39" : "Manual"

}

const LANG_CN = {
    "text_00" : "查理(CHARLI）",
    "text_01" : "请登录后使用",
    "text_02" : "设定问候信息",
    "text_03" : "菜单位置",
    "text_04" : "聊天机器人主题",
    "text_05" : "用问候信息，请打开想要得到的信息！",
    "text_06" : "最多可设定5个问候信息。",
    "text_07" : "实时TOP答复",
    "text_08" : "需要帮助吗？",
    "text_09" : "自动完成功能",
    "text_10" : "收藏夹",
    "text_11" : "还没有喜欢问的问题😥<br/>向查理输入问题后，点击提问对话框的☆就可以登录为喜欢问的问题。😉",
    "text_12" : "添加常见问题",
    "text_13" : "上面问题要添加到常见问题中吗？",
    "text_14" : "常见问题最多可以注册5个😥<br/>删除已注册的问题后即可注册！",
    "text_15" : "常见问题删除",
    "text_16" : "想从常见问题中删除上面的问题吗？",
    "text_17" : "聊天机器人意见与建议",
    "text_18" : "请给我一些关于聊天机器人的建议😀",
    "text_19" : "填写宝贵的意见",
    "text_20" : "填写时请注意，不要包含不必要的个人信息。",
    "text_21" : "请为所填写的问题输入适合的答案。（字数限制1000字）",
    "text_22" : "收到您宝贵的意见。",
    "text_23" : "我是中央大学chatbot",
    "text_24" : "登录",
    "text_25" : "左",
    "text_26" : "右",
    "text_27" : "登出",
    "text_28" : "",
    "text_29" : "确认",
    "text_30" : "是的",
    "text_31" : "不",
    "text_32" : "问候语设置尚不可用。",
    "text_33" : "发送",
    "text_34" : "请选择.",
    "text_35" : "选择",
    "text_36" : "未查询实时TOP答复。",
    "text_37" : "使用 GPT",
    "text_38" : "自动",
    "text_39" : "手动"

}
const LANG_JA = {
    "text_00" : "チャーリー(CHARLI)",
    "text_01" : "ログイン後にご利用ください",
    "text_02" : "グリーティングメッセージ設定",
    "text_03" : "メニュー位置",
    "text_04" : "チャットボットテーマ",
    "text_05" : "グリーティングメッセージとして受け取りたい情報をONにしてください！",
    "text_06" : "グリーティングメッセージは最大5件まで設定できます。",
    "text_07" : "リアルタイムTOP回答",
    "text_08" : "質問を入力してください。",
    "text_09" : "自動補完機能",
    "text_10" : "お気に入りの質問",
    "text_11" : "まだお気に入りの質問がありません😥<br/>チャーリーに質問を入力した後、質問吹き出しの<span className=\"ico_comm ico_bookmark\">ブックマーク</span>を<br/>押すとお気に入りの質問として登録できます😉",
    "text_12" : "お気に入りの質問を追加",
    "text_13" : "この質問をお気に入りの質問に追加しますか？",
    "text_14" : "お気に入りの質問は最大10件まで<br/>登録可能です😥<br/>登録済みの質問を削除してから<br/>登録してください！",
    "text_15" : "お気に入りの質問を削除",
    "text_16" : "この質問をお気に入りの質問から削除しますか？",
    "text_17" : "チャーリー(CHARLI)へのご意見提案",
    "text_18" : "チャーリー(CHARLI)に関するご意見を<br/>お聞かせください😀",
    "text_19" : "貴重なご意見の記入",
    "text_20" : "不要な個人情報が含まれないようにご注意ください。",
    "text_21" : "皆様の貴重なご意見をご入力ください。（文字数は1000文字まで）",
    "text_22" : "貴重なご意見を受け付けました。",
    "text_23" : "中央大学チャットボット",
    "text_24" : "ログイン",
    "text_25" : "左",
    "text_26" : "右",
    "text_27" : "ログアウト",
    "text_28" : "様",
    "text_29" : "確認",
    "text_30" : "はい",
    "text_31" : "いいえ",
    "text_32" : "グリーティングメッセージ設定は準備中です。",
    "text_33" : "送信",
    "text_34" : "選択してください。",
    "text_35" : "選択",
    "text_36" : "リアルタイムTOP回答が表示されませんでした。",
    "text_37" : "GPTを使用",
    "text_38" : "じどう",
    "text_39" : "しゅどう"
}


const LANG_VI = {
    "text_00" : "Charlie (CHARLI)",
    "text_01" : "Vui lòng đăng nhập để sử dụng",
    "text_02" : "Cài đặt tin nhắn chào",
    "text_03" : "Vị trí menu",
    "text_04" : "Chủ đề chatbot",
    "text_05" : "Hãy bật những thông tin bạn muốn nhận trong tin nhắn chào!",
    "text_06" : "Bạn có thể cài đặt tối đa 5 tin nhắn chào.",
    "text_07" : "Câu trả lời TOP theo thời gian thực",
    "text_08" : "Vui lòng nhập câu hỏi.",
    "text_09" : "Chức năng tự động hoàn thành",
    "text_10" : "Câu hỏi yêu thích",
    "text_11" : "Bạn chưa có câu hỏi yêu thích 😥<br/>Sau khi nhập câu hỏi cho Charlie, nhấn <span className=\"ico_comm ico_bookmark\">bookmark</span> trên bong bóng câu hỏi<br/> để thêm vào câu hỏi yêu thích 😉",
    "text_12" : "Thêm câu hỏi yêu thích",
    "text_13" : "Bạn có muốn thêm câu hỏi này vào câu hỏi yêu thích không?",
    "text_14" : "Chỉ có thể đăng ký tối đa 10 câu hỏi yêu thích 😥<br/>Vui lòng xóa câu hỏi đã đăng ký trước khi thêm mới!",
    "text_15" : "Xóa câu hỏi yêu thích",
    "text_16" : "Bạn có muốn xóa câu hỏi này khỏi câu hỏi yêu thích không?",
    "text_17" : "Đề xuất ý kiến về Charlie (CHARLI)",
    "text_18" : "Vui lòng gửi ý kiến của bạn về Charlie (CHARLI) 😀",
    "text_19" : "Viết ý kiến quý giá",
    "text_20" : "Hãy chú ý không bao gồm thông tin cá nhân không cần thiết.",
    "text_21" : "Vui lòng nhập ý kiến quý giá của bạn. (Giới hạn 1000 ký tự)",
    "text_22" : "Ý kiến của bạn đã được ghi nhận.",
    "text_23" : "Chatbot Đại học Chung-Ang",
    "text_24" : "Đăng nhập",
    "text_25" : "Trái",
    "text_26" : "Phải",
    "text_27" : "Đăng xuất",
    "text_28" : "",
    "text_29" : "Xác nhận",
    "text_30" : "Có",
    "text_31" : "Không",
    "text_32" : "Cài đặt tin nhắn chào đang được chuẩn bị.",
    "text_33" : "Gửi",
    "text_34" : "Vui lòng chọn.",
    "text_35" : "Chọn",
    "text_36" : "Không tìm thấy câu trả lời TOP theo thời gian thực.",
    "text_37" : "Sử dụng GPT",
    "text_38" : "Tự động",
    "text_39" : "Thủ công"
}



export { LANG_KO, LANG_EN, LANG_CN, LANG_JA, LANG_VI};